import { MerkleDrop } from '@/types/merkle'
import { SupportedChainId } from './chains'

export const MERKLE_DROP_EIGEN_STAKEDROP_RSWETH_MAINNET: MerkleDrop = {
  address: '0x263190d31d1e7c46de703ecedc46fd425afdefd3',
  chainId: SupportedChainId.MAINNET,
}
